import React, { Component } from 'react'
import { Map } from 'immutable'
import { connect } from 'react-redux'

import config from '../../../../../../../../config'

function mapStateToProps(state, hocProps) {
    const blockData = state.getIn(
        ['ui', 'modules', hocProps.module, 'workspace', hocProps.id, 'blocks', hocProps.blockKey],
        Map()
    )
    const blocks = state.getIn(['ui', 'workspace', hocProps.module, hocProps.id, 'blocks'], Map())

    return {
        disable: blocks.getIn([hocProps.blockKey, 'disable'], false),
        loading: blockData.get('isLoading', false),
        open: blocks.getIn([hocProps.blockKey, 'open'], config.components.block.open),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
